import {useParams} from 'react-router-dom';

import {domainMonitorAPI} from 'features/domain/api/domainMonitorAPI';
import {DomainMonitorBackgroundKind, getDomainMonitorBackgroundKind} from 'features/domain/lib/domainMonitorView';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';
import {isTranslate} from 'shared/lib/lang';
import {getPollingInterval} from 'shared/api/pollingHelper';

import {IDomainMonitorItem} from './DomainMonitor/IDomainMonitor';

export interface IUseDomainMonitorDetails {
    domainMonitor: IDomainMonitorItem | undefined,
    isLoading: boolean,
    isMobile: boolean,
    backgroundKind: DomainMonitorBackgroundKind,
}

export const useDomainMonitorDetails = (): IUseDomainMonitorDetails => {
    const {domainMonitorId} = useParams<{domainMonitorId: string}>();
    const breakpoint = useBreakpoint();

    const {data: domainMonitor, isLoading} = domainMonitorAPI.useGetDomainMonitorQuery(domainMonitorId ?? '', {
        skip: !domainMonitorId,
        pollingInterval: getPollingInterval(),
    });

    return {
        domainMonitor,
        isLoading,
        isMobile: breakpoint === 'small' || breakpoint === 'mini',
        backgroundKind: getDomainMonitorBackgroundKind(!!domainMonitor?.active, isTranslate()),
    };
};

export default useDomainMonitorDetails;
